// apis answers errors as {message} and/or {reason}; reason is a plain string now but was an error object before.
// A specific reason wins over message, which some routes keep generic ("Unable to update session").
export function api_error_message(e, fallback = 'Some error occured. Please contact dev team.') {
  const d = e?.response?.data || {};
  if (typeof d.reason === 'string' && d.reason) return d.reason;
  if (typeof d.reason?.message === 'string' && d.reason.message) return d.reason.message;
  if (typeof d.message === 'string' && d.message) return d.message;
  return fallback;
}
